import type { OfferType } from '@makemydeal/dr-platform-types';

export const formatOfferTypeLabel = (offerType?: OfferType): string =>
    offerType ? `${offerType.charAt(0).toUpperCase()}${offerType.slice(1)}` : '';
